import CircularProgress from "@material-ui/core/CircularProgress";
import React from "react";
import Grid from "@material-ui/core/Grid";

export default function CustomSpinner() {
  return (
    <Grid
      container
      spacing={0}
      direction="column"
      alignItems="center"
      justifyContent="center"
      style={{ minHeight: "75vh" }}
    >
      <CircularProgress color="secondary" />
    </Grid>
  );
}
